export function formatDate(date, format = 'YYYY-MM-DD') {
  const d = new Date(date);

  const map = {
    YYYY: d.getFullYear(),
    MM: ('0' + (d.getMonth() + 1)).slice(-2), // Months are 0-based
    DD: ('0' + d.getDate()).slice(-2),
    HH: ('0' + d.getHours()).slice(-2),
    mm: ('0' + d.getMinutes()).slice(-2),
    ss: ('0' + d.getSeconds()).slice(-2),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/gi, (matched) => map[matched]);
}